import { useQuery } from 'react-query'

import { ACCOUNTS_QUERY_KEY } from 'features/accounts/constants'
import type { AccountsService } from 'features/accounts/service'
import type { Account } from 'features/accounts/types'

type UseAccountsResult = {
  accounts: Account[]
  isLoading: boolean
}

export function useAccounts(service: AccountsService): UseAccountsResult {
  const { data, isLoading } = useQuery<Account[]>(
    [ACCOUNTS_QUERY_KEY],
    () => service.listAccounts(),
    { refetchOnWindowFocus: false },
  )
  return { accounts: data ?? [], isLoading }
}
